import React from "react";
import { LegacySpinnerContainer, SpinnerDetails, SpinnerBackground } from "./styled";

const LegacySpinner = ({loadingContent, width}) => {
    return (<>
    <LegacySpinnerContainer >
        <SpinnerBackground />
        <SpinnerDetails width={width}>
            <div class="ml-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div>
                { loadingContent ? loadingContent : <label>Loading...</label> }
            </div>
        </SpinnerDetails>
</LegacySpinnerContainer>
</>)
};

export default LegacySpinner;